import React from 'react';
import { Radio } from 'antd';
import LookupField from '../../../components/LookupField';
import type { FP630 } from '../../../services/pwp253Api';

interface Props {
  formData: Partial<FP630>;
  isEditing: boolean;
  customerName: string;
  onChange: (field: keyof FP630, value: any) => void;
  onCustomerCodeConfirm: (code: string) => void;
}

const SHIPPING_TYPES = [
  { value: 1, label: '送外加工' },
  { value: 2, label: '內銷出貨' },
  { value: 3, label: '退回/退修' },
];

const Tab1BasicInfo: React.FC<Props> = React.memo(({
  formData, isEditing, customerName, onChange, onCustomerCodeConfirm,
}) => {
  return (
    <div className="pwp253-form-grid">
      <label>送貨單號</label>
      <input
        className="pwp253-input"
        value={formData.fp630_01 || ''}
        disabled
        readOnly
      />

      <label>出庫通知單號 *</label>
      <input
        className="pwp253-input"
        value={formData.fp630_10 || ''}
        onChange={e => onChange('fp630_10', e.target.value)}
        disabled={!isEditing || (isEditing && !!formData.fp630_01)}
        maxLength={5}
      />

      <label>日期</label>
      <input
        className="pwp253-input"
        type="date"
        value={formData.fp630_11 ? formData.fp630_11.substring(0, 10) : ''}
        onChange={e => onChange('fp630_11', e.target.value ? e.target.value + 'T00:00:00Z' : null)}
        disabled={!isEditing}
      />

      <label>客戶代號</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <LookupField
          lookupType="packingCustomer"
          value={formData.fp630_14 || ''}
          onChange={(code: string) => onChange('fp630_14', code)}
          onCodeConfirm={onCustomerCodeConfirm}
          disabled={!isEditing}
          maxLength={12}
          style={{ flex: 1 }}
        />
        <span className="pwp253-lookup-name">
          {customerName || (formData.fp630_14 ? '*查無此代號*' : '')}
        </span>
      </div>

      <label>出貨別</label>
      <Radio.Group
        value={formData.fp630_12 || 1}
        onChange={e => onChange('fp630_12', e.target.value)}
        disabled={!isEditing}
      >
        {SHIPPING_TYPES.map(t => (
          <Radio key={t.value} value={t.value}>{t.label}</Radio>
        ))}
      </Radio.Group>

      <label>使用訂單號碼</label>
      <input
        className="pwp253-input"
        value={formData.fp630_16 || ''}
        onChange={e => onChange('fp630_16', e.target.value)}
        disabled={!isEditing}
        maxLength={20}
      />

      <label>產品規格</label>
      <textarea
        className="pwp253-textarea"
        value={formData.fp630_13 || ''}
        onChange={e => onChange('fp630_13', e.target.value)}
        disabled={!isEditing}
        rows={4}
      />

      <label>建立人</label>
      <input className="pwp253-input" value={formData.fp630_93 || ''} disabled readOnly />

      <label>修改人</label>
      <input className="pwp253-input" value={formData.fp630_91 || ''} disabled readOnly />
    </div>
  );
});

export default Tab1BasicInfo;
